"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CREATE_HOST_ACCOUNT_MUTATION = exports.CREATE_BUSINESS_GUEST_ACCOUNT_MUTATION = exports.CREATE_STANDARD_GUEST_ACCOUNT_MUTATION = exports.AUTHENTICATE_USER_MUTATION = void 0;
const client_1 = require("@apollo/client");
exports.AUTHENTICATE_USER_MUTATION = client_1.gql `
  mutation AuthenticateGuest($input: AuthenticateGuestInput!) {
    authenticateGuest(input: $input) {
      jwt
      refreshToken
      user {
        id
        companyName
        email
        firstName
        lastName
        roles
        companyID
        avatar
      }
    }
  }
`;
exports.CREATE_STANDARD_GUEST_ACCOUNT_MUTATION = client_1.gql `
  mutation CreateStandardGuestAccount($input: CreateStandardGuestAccountInput!) {
    createStandardGuestAccount(input: $input) {
      refreshToken
      jwt
      user {
        id
        companyName
        email
        firstName
        lastName
        roles
        companyID
        avatar
      }
    }
  }
`;
exports.CREATE_BUSINESS_GUEST_ACCOUNT_MUTATION = client_1.gql `
  mutation CreateBusinessGuestAccount($input: CreateBusinessGuestAccountInput!) {
    createBusinessGuestAccount(input: $input) {
      refreshToken
      jwt
      user {
        id
        companyName
        email
        firstName
        lastName
        roles
        companyID
        avatar
      }
    }
  }
`;
exports.CREATE_HOST_ACCOUNT_MUTATION = client_1.gql `
  mutation CreateHostAccount($input: CreateHostAccountInput!) {
    createHostAccount(input: $input) {
      refreshToken
      jwt
      user {
        id
        companyName
        email
        firstName
        lastName
        roles
        companyID
        avatar
      }
    }
  }
`;
